import React from "react";

const PaidMemberChats = () => {
  return <div>PaidMemberChats</div>;
};

export default PaidMemberChats;
